import { tState } from "@src/Model/Model"
import {
  getUpdateDashboardMonitoringWatcher,
  getUpdateDashboardWatcher,
} from "@src/Sagas"
import * as React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"

import Dashboard from "./Dashboard"

const DashboardContainer = () => {
  const { modules } = useSelector((state: tState) => state.plans)
  const history = useHistory()
  const dispatch = useDispatch()

  React.useEffect(() => {
    dispatch(getUpdateDashboardWatcher())
    dispatch(getUpdateDashboardMonitoringWatcher())
  }, [dispatch])

  const setView = React.useCallback(
    (view: string) => history.push(view),
    [history],
  )

  return <Dashboard modules={modules} changeView={setView} />
}

export default DashboardContainer
